export const PLUGINS = {
    FETCH_PLUGIN: 'fetchPlugin',
    FETCH_PLUGINS: 'fetchPlugins',
    FETCH_DOWNLOADS: 'fetchDownloads',
    FETCH_PLUGIN_LICENSE: 'fetchPluginLicense',
    DELETE_PLUGIN_DOMAIN: 'deletePluginDomain',
}
